var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]),_c('qrcode-stream',{key:_vm._uid,staticStyle:{"width":"300px","height":"300px"},attrs:{"track":_vm.selected.value},on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }